'use strict';
import { LogHelper } from 'com-gyf-webcore-loghelper';

import {
    ASIENTOSCONTABLES_ACTUALIZAR_DATOSEXCEL,
    ASIENTOSCONTABLES_ACTUALIZAR_FECHA,
    ASIENTOSCONTABLES_ACTUALIZAR_FECHA_SELECTOR,
    ASIENTOSCONTABLES_ACTUALIZAR_MENSAJE_ERROR,
    ASIENTOSCONTABLES_ACTUALIZAR_MODELOS_MARCA,
    ASIENTOSCONTABLES_CAMBIAR_CHECK,
    ASIENTOSCONTABLES_CAMBIAR_RESULTADO,
    ASIENTOSCONTABLES_CAMBIAR_VALOR_INPUT,
    ASIENTOSCONTABLES_CARGAR_INFORMACION_COMBOS_FILTROS_ADICIONALES,
    ASIENTOSCONTABLES_CARGAR_DATOS_COMBOS,
    ASIENTOSCONTABLES_CARGAR_ESTADOS_ASIENTOS,
    ASIENTOSCONTABLES_DESPLEGAR_DATOS_ADICIONALES,
    ASIENTOSCONTABLES_DESPLEGAR_DATOS_DETALLE_ASIENTO,
    ASIENTOSCONTABLES_DESPLEGAR_FILTROS,
    ASIENTOSCONTABLES_FILTRAR_MODELOS,
    ASIENTOSCONTABLES_GUARDAR_QUITAR_MODELO_SELECCIONADO,
    ASIENTOSCONTABLES_GUARDAR_USUARIO_ACTUAL,
    ASIENTOSCONTABLES_GUARDAR_VALOR_COMBO_TEMPORAL,
    ASIENTOSCONTABLES_MOSTRAR_MODAL,
    ASIENTOSCONTABLES_MOSTRAR_MODAL_MENSAJE_RESULTADO,
    ASIENTOSCONTABLES_CARGAR_PERMISOS_USUARIO,
    ASIENTOSCONTABLES_OCULTAR_BOTON_VERMAS,
    ASIENTOSCONTABLES_SELECCIONAR_VALOR_COMBO,
    ASIENTOSCONTABLES_MOSTRAR_SPINNER,
    ASIENTOSCONTABLES_POBLAR_GRILLA,
    ASIENTOSCONTABLES_CARGA_INICIAL_FILTRO,
    ASIENTOSCONTABLES_CARGAR_DATOS_MODELO,
    ASIENTOSCONTABLES_GUARDAR_DATOS_REGISTRO_REPROCESO,
    ASIENTOSCONTABLES_CARGAR_DATOS_ASIENTO_CONTABLE,
    ASIENTOSCONTABLES_DESPLEGAR_DATOS_DETALLE_RENGLON,
    ASIENTOSCONTABLES_DESPLEGAR_DATOS_DETALLE_RENGLON_NUEVO_ASIENTO,
    ASIENTOSCONTABLES_REINICIAR_CAMPOS_MODAL,
    ASIENTOSCONTABLES_CARGA_INICIAL_NUEVO_ASIENTO,
    ASIENTOSCONTABLES_FILTRAR_CUENTAS,
    ASIENTOSCONTABLES_SELECCIONAR_OPCION_COMBO,
    ASIENTOSCONTABLES_INPUT_ACTIVO,
    ASIENTOSCONTABLES_GESTIONAR_RENGLON_MANUAL,
    ASIENTOSCONTABLES_CARGAR_RENGLONES_MANUALES,
    ASIENTOSCONTABLES_MODIFICAR_ESTADO_ASIENTO,
    ASIENTOSCONTABLES_ACTUALIZAR_COMENTARIOS,
    LIMPIAR_MODAL_ASIENTOS_CONTABLES,
    ASIENTOSCONTABLES_SET_ORIGEN_LLAMADO_MODA_BAJA,
    INITIAL_STATE
    
} from '../../Screens/AsientosContables/actions/Actions';

const initialState = {
    arrayResultadoSp: [],                                                  //Array que contiene los registros obtenidos desde la base de datos.
    modalConfirmarDetalleAsiento: false,                                        //Flag utilizado para mostrar u ocultar el modal de "Confirmación de detalle de asiento".
    modalNuevoAsiento: false,                                                   //Flag utilizado para mostrar u ocultar el modal de "Nuevo Asiento".
    modalDetalleAsiento: false,                                                 //Flag utilizado para mostrar u ocultar el modal de "Detalle del asiento".
    modalSeleccionModelos: false,                                               //Flag utilizado para mostrar u ocultar el modal de "Seleccionar modelos".
    modalConfirmarEliminacionModelos: false,                                    //Flag utilizado para mostrar u ocultar el modal de "Confirmación de borrado de modelos seleccionados".
    modalConfirmarBajaAsientos: false,
    datosExcelAsientosContables:[],                                         //Array que contiene los datos para la exportacion de excel de los detalles de los asientos.
    detallesModeloElegido:[],                                               //Array que contiene los datos del modelo elegido en un nuevo asiento
    modelosContablesActivos: [],                                                //Array que contiene los modelos contables activos desde la obtención de datos.
    permisosUsuario: [],                                                        //Array con los permisos sobre el Feature de CONTABILIDAD que tiene el usuario logeado.
    usuarioLogin:"",                                                          //Variable que guarda el login del usuario
    arrayResultadoBusquedaAsientos:[],
    mostrarVerMas: true,                                                        //Flag utilizado para mostrar u ocultar el botón de "Ver más..." en la pantalla principal, en el caso de que haya más de 8 modelos seleccionados.
    valorComboMarcaTemporal: "0",                                               //Variable que guarda temporalmente la opción seleccionada del combo de "Marcas" para hacer efectivo el cambio de opción siempre y cuando haya confirmado desde el modal "modalConfirmarEliminacionModelos".
    estaDesplegado: false,                                                      //Flag que determina si la sección adicional de filtros está desplegada o no.
    mostrarSpinner: false,                                                      //Flag que indica si el spinner de carga debe mostrarse o no.                                    //Variable que guarda el nombre de la opción seleccionada a desplegar para el modal de Detalle de Asiento. Los valores posibles son "datosAuditoria" o "datosReproceso".
    fechaActual: new Date().toLocaleDateString('en-GB'),                        //Variable que guarda la fecha del dia para usarlo en distintos componentes.
    origenLlamadoModalBaja: "",
    combosFiltrosAdicionales: {
		datosSucursales: [],                                                        //Array que contiene los datos de sucursales obtenidos del SP.
		datosEstados: [],                                                           //Array que contiene los datos de estados obtenidos del SP.
		datosMonedas: [],                                                           //Array que contiene los datos de monedas obtenidos del SP.
	 },             
    marcasActivas: [],                                                          //Array que contiene las marcas activas desde la obtención de datos.
    modelosFiltrados: [],    
    comboEstadosAsientos:[],                                                      //Array que contiene los datos de estados de los asientos para el modal de detalle.
    registroDesplegado: null,                                                    //Variable que guarda el Id del registro cuya información adicional tiene desplegada.     
    estadosAsientos:[],
    modalAsientosContables:{
        renglonesContablesAsiento:[],
        renglonesContablesModelo:[],
        cuentasContables:[],
        centrosCosto:[],
        detalleRenglonDatosDesplegados: null,                                             //Variable que guarda el registro para cargar sus datos en el modal de detalle.
        registroDetalle: null,
        registroDatosReproceso: null,
        detalleAsientoDatosDesplegados: null,
        inputActivo:"",
        estadoAsientoContable:null,
        nuevoRenglonTemplate: {
            DescripcionRenglon: '',
            CuentaContableCodigo: '',
            CuentaContableDescripcion: '',
            CuentaContableId: null,
            TipoOperacion:null,
            MonedaSalidaCodigo:"PESO",
            ModeloMonedaSalidaId:null,
            ImporteAsiento: '',
            TipoRenglon: 2,
            RenglonAgregadoManualmente: true,
            ReferenciaRenglon: null,
            TipoReferencia:0,
            CentroCostoId: null,
            EliminaRenglon: false,
            cuentasContablesFiltradas:[],
        },
        renglonesAgregadosManualmente: [],
        renglonesManualesFiltrados:[],
        renglonesAsientoIdentificados:[]
    },
    propsModalNuevoAsiento:{
        selectorFechaNuevoAsiento: new Date().toLocaleDateString('en-GB'),     //Variable que guarda la información ingresada por el usuario para el input de "Fecha valor contable".
        detalleRenglonDatosDesplegados: null,
        centrosCosto:[],
        cuentasContables:[],
        modelosManuales: [],                                                           //Array que guarda los datos de los modelos manuales obtenido por SP.
        registroDetalle: null,
        nuevoRenglonTemplate: {
            DescripcionRenglon: '',
            CuentaContableCodigo: '',
            CuentaContableDescripcion: '',
            CuentaContableId: null,
            ImporteAsiento: '',
            TipoRenglon: 2,
            RenglonAgregadoManualmente: true,
            MonedaSalidaCodigo:"PESO",
            ModeloMonedaSalidaId:null,
            ValorReferencia: null,
            CentroCostoId: null,
            TipoReferencia:0,
            cuentasContablesFiltradas:[],
        },
        renglonesAgregadosManualmente:[],
        renglonesManualesFiltrados:[],
        comentarios:"",
        inputCuentaContable:"",
        inputActivo:""
    },
    inputsAsientosContables: {                                                  //Objeto que guarda toda la información relacionada a inputs de la pantalla de Asientos Contables.
        inputFechaContabilizacionDesde: new Date().toLocaleDateString('en-GB'),     //Variable que guarda la información ingresada por el usuario para el input de "Fecha contabilización" (fecha desde).
        inputFechaContabilizacionHasta: new Date().toLocaleDateString('en-GB'),     //Variable que guarda la información ingresada por el usuario para el input de "Fecha contabilización" (fecha hast).
        inputFechaValorDesde: new Date().toLocaleDateString('en-GB'),               //Variable que guarda la información ingresada por el usuario para el input de "Fecha valor" (fecha desde).
        inputFechaValorHasta: new Date().toLocaleDateString('en-GB'),               //Variable que guarda la información ingresada por el usuario para el input de "Fecha valor" (fecha hasta).
        inputFechaRendicionDesde: new Date().toLocaleDateString('en-GB'),           //Variable que guarda la información ingresada por el usuario para el input de "Fecha de rendición al Core" (fecha desde).
        inputFechaRendicionHasta: new Date().toLocaleDateString('en-GB'),           //Variable que guarda la información ingresada por el usuario para el input de "Fecha de rendición al Core" (fecha hasta).
        inputIdAsiento: "",                                                         //Variable que guarda la información ingresada por el usuario para el input de "ID Asiento".
        modalSeleccionModelos: {                                                    //Objeto que guarda toda la información relacionada a inputs del modal "modalSeleccionModelos".
            modelosContablesSeleccionados: [],                                          //Array que contiene los modelos contables seleccionados desde el modal.
            modelosContablesFiltrados: [],                                              //Array que contiene los modelos contables filtrados a través de lo ingresado en el input del buscador de modelos contables.
            inputBuscadorModelos: ""
        },
        modalAsientosContables:{
            inputCuentaContable:""
        },
        propsModalNuevoAsiento:{
            inputCuentaContable:""
        }
    },
    combosAsientosContables: {                                                  //Objeto que guarda toda la información relacionada a combos de la pantalla de Asientos Contables.
        comboMarca: "0",                                                            //Variable que guarda el valor de la opción seleccionada del combo de "Marcas"
        comboSucursal: "0",                                                         //Variable que guarda el valor de la opción seleccionada del combo de "Sucursales"
        comboEstado: "0",                                                           //Variable que guarda el valor de la opción seleccionada del combo de "Estados"
        comboMoneda: "0",                                                           //Variable que guarda el valor de la opción seleccionada del combo de "Monedas"
        comboAccionMasiva: "0",                                                     //Variable que guarda el valor de la opción seleccionada del combo de "Acción masiva"
        comboModeloNuevoAsiento: "0"                                                //Variable que guarda el valor de la opcion seleccionada del combo de "Modelos" del modal Nuevo Asiento
    },
    checksAsientosContables: {                                                  //Objeto que guarda toda la información relacionada a checkboxes de la pantalla de Asientos Contables.
        checkFechaContabilizacion: true,                                            //Flag que determina si el check de "Fecha Contabilización" está tildado o no.
        checkFechaValor: true,                                                      //Flag que determina si el check de "Fecha valor" está tildado o no.
        checkSoloNoBalanceados: false,                                              //Flag que determina si el check de "Sólo no balanceados" está tildado o no.
        checkSoloIngresadosModificadosManualmente: false,                           //Flag que determina si el check de "Sólo ingresados/modificados manualmente" está tildado o no.
        checkSoloConfirmadosManualmente: false,                                     //Flag que determina si el check de "Sólo confirmados manualmente" está tildado o no.
        checkSoloDadosBaja: false,                                                  //Flag que determina si el check de "Sólo dados de baja" está tildado o no.
        checkFechaRendicion: false,                                                 //Flag que determina si el check de "Fecha de rendición al Core" está tildado o no.
        checkTodosAsientosContables: false,                                         //Flag que determina si el check de "Fecha de rendición al Core" está tildado o no.
        modalSeleccionModelos: {                                                    //Objeto que guarda la información de los checkboxes del modal "modalSeleccionModelos".
            checkTodosModelos: true                                                     //Flag que determina si el check de "Seleccionar todos los modelos" está tildado o no.
        }
    },
    errorValidacion: {                                      //Objeto contenedor creado para guardar la información de errores de validación de componentes que deban validarse.
        inputFechaContabilizacionDesde: false,                  //Flag que guarda la fecha "Desde" ingresada para el input de "Fecha Contabilización"
        inputFechaContabilizacionHasta: false,                  //Flag que guarda la fecha "Hasta" ingresada para el input de "Fecha Contabilización"
        inputFechaContabilizacionContenedor: "",                //Variable que contendrá el mensaje de validación (en caso de error) para el grupo de datepickers de "Fecha Contabilización"
        inputFechaValorDesde: false,                            //Flag que guarda la fecha "Desde" ingresada para el input de "Fecha Valor"
        inputFechaValorHasta: false,                            //Flag que guarda la fecha "Hasta" ingresada para el input de "Fecha Valor"
        inputFechaValorContenedor: "",                          //Variable que contendrá el mensaje de validación (en caso de error) para el grupo de datepickers de "Fecha Valor"
        inputFechaRendicionDesde: false,                        //Flag que guarda la fecha "Desde" ingresada para el input de "Fecha Rendición"
        inputFechaRendicionHasta: false,                        //Flag que guarda la fecha "Hasta" ingresada para el input de "Fecha Rendición"
        inputFechaRendicionContenedor: ""                       //Variable que contendrá el mensaje de validación (en caso de error) para el grupo de datepickers de "Fecha Rendición"
    }
}

function asientosContables(state = initialState, action) {
    LogHelper.In(asientosContables.name, state, action);
    let result;

    switch (action.type) {
        case INITIAL_STATE: {
            state = initialState;


            result = {
                ...state
            }
        }
        break;


        case ASIENTOSCONTABLES_MOSTRAR_MODAL: {
            result = {
                ...state,
                [action.nombreModal]: action.mostrarModal
            };
        }
        break;
        
        case ASIENTOSCONTABLES_MOSTRAR_SPINNER: {
            result = {
                ...state,
                mostrarSpinner: action.valor
            }
        }
        break;

        case ASIENTOSCONTABLES_CARGAR_DATOS_MODELO: {
            result = {
                ...state,
                detallesModeloElegido: action.detallesModelo
            };
        }
        break;

        case ASIENTOSCONTABLES_CARGAR_PERMISOS_USUARIO: {
            result = {
                ...state,
                permisosUsuario: action.permisos
            }
        }
        break;


        case ASIENTOSCONTABLES_GUARDAR_USUARIO_ACTUAL: {
            result = {
                ...state,
                usuarioLogin: action.usuarioLogin
            }
        }
        break;

        case ASIENTOSCONTABLES_POBLAR_GRILLA: {
          let inputs = JSON.parse(JSON.stringify(state.inputsAsientosContables));

            inputs.modalSeleccionModelos.modelosContablesSeleccionados = action.modelosContables;
         
            result = {
                ...state,
                inputsAsientosContables: inputs,
                modelosContablesActivos : action.modelosContables
            }
        }
        break;

        case ASIENTOSCONTABLES_MOSTRAR_MODAL_MENSAJE_RESULTADO: {
            result = {
                ...state,
                modalMensajeResultado: action.mensaje,
                redireccionarPantallaPrincipal: action.redireccionarPantallaPrincipal
            }
        }
        break;

        case ASIENTOSCONTABLES_CARGA_INICIAL_FILTRO: {
            result = {
                ...state,
                marcasActivas: action.marcasActivas,
                modelosFiltrados: action.modelosFiltrados,
            }
        }
        break;

        case ASIENTOSCONTABLES_FILTRAR_MODELOS: {
            result = {
                ...state,
                inputsAsientosContables: action.inputs
            }
        }
        break;


        case ASIENTOSCONTABLES_GUARDAR_QUITAR_MODELO_SELECCIONADO: {
            result = {
                ...state,
                inputsAsientosContables: action.inputs,
                checksAsientosContables: action.checks,
                mostrarVerMas: action.mostrarVerMas
            }
        }
        break;

        case ASIENTOSCONTABLES_OCULTAR_BOTON_VERMAS: {
            result = {
                ...state,
                mostrarVerMas: false
            }
        }
        break;


        case ASIENTOSCONTABLES_SELECCIONAR_VALOR_COMBO: {
            result = {
                ...state,
                inputsAsientosContables: action.inputs,
                combosAsientosContables: action.combos,
                checksAsientosContables: action.checks,
                mostrarVerMas: action.mostrarVerMas
            }
        }
        break;

        case ASIENTOSCONTABLES_ACTUALIZAR_MODELOS_MARCA: {
            result = {
                ...state,
                inputsAsientosContables: action.inputs,
                modelosContablesActivos : action.modelosContables
            }
        }
        break;

        case ASIENTOSCONTABLES_GUARDAR_VALOR_COMBO_TEMPORAL: {
            result = {
                ...state,
                valorComboMarcaTemporal: action.valorCombo
            }
        }

        case ASIENTOSCONTABLES_GUARDAR_DATOS_REGISTRO_REPROCESO: {
            result = {
                ...state,
                modalAsientosContables: {
                ...state.modalAsientosContables,
                registroDatosReproceso: action.datos
               }
            }
        }
      break;
      
        case ASIENTOSCONTABLES_DESPLEGAR_FILTROS: {
            result = {
                ...state,
                estaDesplegado: action.estaDesplegado
            }
        }
        break;


        case ASIENTOSCONTABLES_ACTUALIZAR_FECHA: {
            result = {
                ...state,
                inputsAsientosContables: action.inputs
            }
        }
        break;

        case ASIENTOSCONTABLES_ACTUALIZAR_FECHA_SELECTOR: {
            return {
                ...state,
                propsModalNuevoAsiento: {
                    ...state.propsModalNuevoAsiento,
                    selectorFechaNuevoAsiento: action.fechaNuevoAsiento
                }
            };
        }

        case ASIENTOSCONTABLES_ACTUALIZAR_MENSAJE_ERROR: {

            result = {                
                ...state,
                errorValidacion: action.errorValidacion
            };
        }
        break;


        case ASIENTOSCONTABLES_CAMBIAR_CHECK: {
            result = {
                ...state,
                checksAsientosContables: action.checks,
                inputsAsientosContables: action.inputs,
            }
        }
        break;

        case ASIENTOSCONTABLES_CAMBIAR_RESULTADO: {
            result = {
                ...state,
                arrayResultadoBusquedaAsientos: action.resultadoBusqueda,
                registroDesplegado: null
            }
        }
        break;

        case ASIENTOSCONTABLES_CARGAR_ESTADOS_ASIENTOS: {
            result = {
                ...state,
                    estadosAsientos: action.estados
                }
        }
        break;


        case ASIENTOSCONTABLES_DESPLEGAR_DATOS_ADICIONALES: {
            result = {
                ...state,
                registroDesplegado: action.idAsiento
                }
        }
        break;


        case ASIENTOSCONTABLES_DESPLEGAR_DATOS_DETALLE_ASIENTO: {
            result = {
                ...state,
                modalAsientosContables: {
                ...state.modalAsientosContables,
                detalleAsientoDatosDesplegados: action.valor
                }
            }
        }
        break;

        case ASIENTOSCONTABLES_DESPLEGAR_DATOS_DETALLE_RENGLON: {
            result = {
                ...state,
                [action.seccionArray]: {
                    ...state[action.seccionArray],
                    detalleRenglonDatosDesplegados: action.valor
                }
            };
        }
        break;

        case ASIENTOSCONTABLES_REINICIAR_CAMPOS_MODAL: {
            result = {
                ...state,
                combosAsientosContables:{
                    ...state.combosAsientosContables,
                    comboModeloNuevoAsiento: 0
                },
                propsModalNuevoAsiento: {
                    ...state.propsModalNuevoAsiento,
                    selectorFechaNuevoAsiento: new Date().toLocaleDateString('en-GB'),     //Variable que guarda la información ingresada por el usuario para el input de "Fecha valor contable".
                    detalleRenglonDatosDesplegados: null,
                    nuevoRenglonTemplate: {
                        DescripcionRenglon: '',
                        CuentaContableCodigo: '',
                        CuentaContableDescripcion: '',
                        ImporteAsiento: '',
                        TipoRenglon: 2,
                        RenglonAgregadoManualmente: true,
                        ValorReferencia: null,
                        CentroCostoId: null,
                        cuentasContablesFiltradas:[],
                    },
                    renglonesAgregadosManualmente:[],
                    renglonesManualesFiltrados:[],
                    comentarios:"",
                    inputCuentaContable:"",
                    inputActivo:""
                },
                detallesModeloElegido:[]
            };
        }
        break;

        case ASIENTOSCONTABLES_ACTUALIZAR_DATOSEXCEL:{
            result = {
                ...state,
                datosExcelAsientosContables: action.datosExcelFinal
            }
        }
        break;
        
        case ASIENTOSCONTABLES_CARGAR_INFORMACION_COMBOS_FILTROS_ADICIONALES: {
            let input = JSON.parse(JSON.stringify(state.combosFiltrosAdicionales));

            input[action.nombreArrayCombo] = action.datosCombo;
            
            result = {
                ...state,
                combosFiltrosAdicionales: input
            }
        }
        break;

        case ASIENTOSCONTABLES_CARGAR_DATOS_COMBOS: {
            let { nombreCombo, datosCombo } = action;
            result = {
                ...state,
                [nombreCombo]: datosCombo
            };
        }
        break;

        case ASIENTOSCONTABLES_CAMBIAR_VALOR_INPUT: {
            let input = JSON.parse(JSON.stringify(state.inputsAsientosContables));
       
            if (action.seccionInput) {
                if (input[action.seccionInput]) {
                    input[action.seccionInput][action.nombreInput] = action.valorInput;
                }
            } else {
                input[action.nombreInput] = action.valorInput;
            }
       
            result = {
                ...state,
                inputsAsientosContables: input
            };
        }
        break;

        case ASIENTOSCONTABLES_SELECCIONAR_OPCION_COMBO: {
            let combos = JSON.parse(JSON.stringify(state.combosAsientosContables));
            combos[action.nombreCombo] = action.valorCombo;

            result = {
                ...state,
                combosAsientosContables: combos,
            }
        }
        break;

        case ASIENTOSCONTABLES_CARGAR_DATOS_ASIENTO_CONTABLE: {
            result = {
                ...state,
                modalAsientosContables: {
                    ...state.modalAsientosContables,
                    renglonesContablesAsiento: action.datosRenglones,
                    renglonesContablesModelo: action.datosRenglonesManuales,
                    cuentasContables: action.datosCuentasContables,
                    registroDetalle: action.registro,
                    centrosCosto: action.datosCentroCosto
                },
                comboEstadosAsientos: action.datosEstadosAsiento
            }
        }
        break;

        case ASIENTOSCONTABLES_CARGA_INICIAL_NUEVO_ASIENTO: {
            let cuentasContables = action.cuentasContables;
           
                result = {
                    ...state,
                    propsModalNuevoAsiento: {
                    ...state.propsModalNuevoAsiento,
                    centrosCosto: action.centrosCosto,
                    cuentasContables: cuentasContables,
                    cuentasContablesFiltradas: cuentasContables,
                    modelosManuales: action.modelosManuales
                }
            }
        }
        break;

        case ASIENTOSCONTABLES_FILTRAR_CUENTAS: {
            let cuentasContablesFiltradas = action.cuentasContablesFiltradas;
           
                result = {
                    ...state,
                    modalAsientosContables: {
                    ...state.modalAsientosContables,
                    cuentasContablesFiltradas: cuentasContablesFiltradas
                }
            }
        }
        break;
 
        case ASIENTOSCONTABLES_INPUT_ACTIVO: {  
            result = {
                ...state,
                [action.seccionInput]: {
                    ...state[action.seccionInput],
                    inputActivo: action.nombreInput
                }
            };
        }
        break;

        case ASIENTOSCONTABLES_GESTIONAR_RENGLON_MANUAL: {
            result = {
                ...state,
                [action.seccionArray]: {
                    ...state[action.seccionArray],
                    [action.nombreArray]: action.renglonesModificados
                },
            }
        }
        break;

        case ASIENTOSCONTABLES_MODIFICAR_ESTADO_ASIENTO: {
      
            result = {
                ...state,
                [action.seccionArray]: {
                    ...state[action.seccionArray],
                    registroDetalle: {
                        ...state[action.seccionArray].registroDetalle,
                        EstadoDescripcionCombo: action.estadoDescripcion,
                        EstadoIdCombo: action.estadoId,
                    }
                },
            }
        }
        break;

        case ASIENTOSCONTABLES_CARGAR_RENGLONES_MANUALES: {
            result = {
                ...state,
                [action.nombreArray]: {
                    ...state[action.nombreArray],
                    renglonesManualesFiltrados: action.renglonesManualesFiltrados,
                    renglonesAsientoIdentificados:action.renglonesAsientoIdentificados
    
                },
            }
        }
        break;

        case ASIENTOSCONTABLES_ACTUALIZAR_COMENTARIOS:{
            result = {
                ...state,
                propsModalNuevoAsiento: {
                ...state.propsModalNuevoAsiento,
                comentarios: action.comentarios
                },
            }
        }
        break;

        case LIMPIAR_MODAL_ASIENTOS_CONTABLES: {
            result = {
                ...state,
                modalAsientosContables: { ...initialState.modalAsientosContables }
            };
        }
        break;

        case ASIENTOSCONTABLES_SET_ORIGEN_LLAMADO_MODA_BAJA: {
            result = {
                ...state,
                origenLlamadoModalBaja: action.origen
            };
        }
        break;
            
    default:
        result = {
            ...state
        };
        break;

    }

    LogHelper.Out(asientosContables.name, result);

    return result;
}


export default asientosContables;